import { createRouter, createWebHistory } from 'vue-router';
import HomeView from '../views/CartasAemps.vue';
import Crear from '../components/CrearAemps.vue';
import Editar from '../components/EditarAemps.vue';
import Listar from '../components/ListarAemps.vue';
import Menu from '../components/MenuAemps.vue';
import HeadAemps from '../components/HeadAemps.vue';
import LoginAemps from '../components/LoginAemps.vue';


const router = createRouter({
history: createWebHistory('/cartasfarmacovigilancia/'),
routes: [
  {
    path: '/', 
    name: 'home',
    component: HomeView,HeadAemps,
    meta: { auth: false, showHeader: false }
  },
  {
    path: '/crear',
    name: 'crear',
    component: Crear,Menu,
    meta: { auth: true, showHeader: true }
  },
  {
    path: '/editar/:id',
    name: 'editar',
    component: Editar,Menu,
    meta: { auth: true, showHeader: true }
  },
  {
    path: '/listar',
    name: 'listar',
    component: Listar,Menu,
    meta: { auth: true, showHeader: true }
  },
  {
    path: '/login',
    name: 'login',
    component: LoginAemps,
    meta: { auth: false, showHeader: true }
  },
],
});

router.beforeEach((to, from, next) => {
  const isAuthenticated = sessionStorage.getItem('isAuthenticated');
  if (to.meta.auth && !isAuthenticated) {
    next('/');
  } else if (!to.meta.auth && isAuthenticated) {
    next('/listar');
  } else {
    next();
  }
});

export default router;
